import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { chatbotEvents } from '../state'
import { leaseTypes } from 'modules/api/portfolio/constants'

export interface LeaseTypeSelectionState {
  leaseType: string
}

export const initialState: LeaseTypeSelectionState = {
  leaseType: leaseTypes.managed,
}

const leaseTypeSelectionSlice = createSlice({
  name: 'chatbot/dialogs/leaseTypeSelection',
  initialState,
  reducers: {
    managedLeaseSelected: state => {
      state.leaseType = leaseTypes.managed
    },
    unmanagedLeaseSelected: state => {
      state.leaseType = leaseTypes.unmanaged
    },
  },
  extraReducers: builder => {
    builder
      .addCase(chatbotEvents.setCurrentPortfolio, (state, action) => {
        state.leaseType = action.payload?.tags?.leaseType ?? leaseTypes.managed
      })
      .addCase(chatbotEvents.resetCurrentPortfolio, () => initialState)
  },
})

export const { reducer } = leaseTypeSelectionSlice
export const leaseTypeSelectionEvents = leaseTypeSelectionSlice.actions
